import { AxiosProgressEvent } from 'axios';
import { useMemo } from 'react';
import { RcFile } from 'antd/es/upload';
import { DefaultFetchError, FetchCreate, useFetchCreate } from '../fetch';

export interface FileData {
  id: string;
  encoding: string;
  fileSize: number;
  location: string;
  mimeType: string;
  originalName: string;
}

export const useFileUpload = (
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
  abortController?: AbortController,
): FetchCreate<FileData, DefaultFetchError, FormData> & {
  fetchFile: (file: RcFile) => Promise<FetchCreate<FileData, DefaultFetchError, FormData>>;
} => {
  const fetchCreate = useFetchCreate(
    'files/upload',
    {
      autoStart: false,
      startStateLoading: false,
      config: {
        headers: {
          'content-type': 'multipart/form-data',
        },
        signal: abortController?.signal,
      },
    },
    onUploadProgress,
  );

  return useMemo(
    () => ({
      ...fetchCreate,
      fetchFile: (file: RcFile) => {
        const formData = new FormData();

        formData.append('file', file);

        return fetchCreate.fetch(formData);
      },
    }),
    [fetchCreate],
  ) as FetchCreate<FileData, DefaultFetchError, FormData> & {
    fetchFile: (file: RcFile) => Promise<FetchCreate<FileData, DefaultFetchError, FormData>>;
  };
};

export default {
  useFileUpload,
};
